import {Color} from '~/constants/style';

export const dashboardContainerStyle = {
  bgcolor: Color.SidebarMain,
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const dashboardTitleStyles = {
  color: Color.Purple600,
  letterSpacing: '0.01em',
  lineHeight: 1,
  fontWeight: 600,
};

export const pricingListButtonStyles = {
  marginRight: '1.5rem',
  display: 'flex',
  alignItems: 'center',
};
export const dashboardCardsContainerStyles = {
  marginTop: '2rem',
  px: 4,
};

const baseGridStyle = {
  ...dashboardCardsContainerStyles,
  display: 'grid',
  gap: 3,
  flex: 1,
  overflowY: 'auto',
  position: 'relative',
  paddingBottom: 2,
};

export const normalGridStyle = {
  ...baseGridStyle,
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
  },
  gridTemplateAreas: {
    xs: `
      "card1"
      "card2"
      "card3"
      "card4"
      "card5"
      "card6"
    `,
    md: `
      "card1 card2 card3"
      "card4 card5 card6"
    `,
  },
  columnGap: 3,
  rowGap: 0,
};

export const expandedGridStyle = {
  ...baseGridStyle,
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(3, 1fr)',
  },
  gridTemplateRows: {
    xs: 'auto',
    md: 'repeat(3, min-content)',
  },
  gridTemplateAreas: {
    xs: `
      "expanded"
      "card1"
      "card2"
      "card3"
      "card4"
      "card5"
    `,
    md: `
      "expanded expanded card1"
      "expanded expanded card2"
      "card3 card4 card5"
    `,
  },
};

export const gridItemStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const expandedCardStyle = {
  gridArea: {
    xs: 'expanded',
    md: 'expanded',
  },
  minHeight: {
    xs: 300,
    md: 340,
  },
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const cardsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 4,
  '& > *': {
    flex: '1 1 calc(33.333% - 32px)',
    minWidth: '300px',
    '@media (max-width: 900px)': {
      flex: '1 1 100%',
    },
  },
};

export const mainBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#f6f2fd',
};

export const headerStackStyles = {
  mb: 5,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '2.5rem',
  px: '1.5rem',
};

export const cardStyle = {
  p: 2.5,
  borderRadius: 3,
  bgcolor: '#FFFFFF',
  minHeight: 227,
  height: 220,
  width: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const dashboardRootContainerStyle = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
};

export const DownLoadReportIconStyle = {
  marginRight: '0.5rem',
};

export const dashboardHeaderButtonBoxStyles = {
  display: 'flex',
  gap: 2,
  marginRight: '0.5rem',
  alignItems: 'center',
  justifyContent: 'flex-end',
};
